import api from "@/components/application/api/api";
import type { AxiosError } from "axios";
import type { AxiosService } from "../interfaces/axiosServiceInterface";

export interface ErrorResponse {
  statusCode: number;
  message: [];
  error: string;
}

export function isGetUserServiceError(data: ErrorResponse | any) {
  return (<ErrorResponse>data)?.statusCode !== undefined;
}

export const createUpdateUserService = (api: AxiosService) => {
  const updateCompanyUser = async (
    id: string,
    profile: any,
    userRole: string
  ): Promise<any> => {
    try {
      if (userRole === "EMPLOYEE") {
        const data = await api.patch<any, any>(
          `/maintenance/employee/${id}`,
          {},
          profile,
          false
        );
        return data;
      } else {
        const data = await api.patch<any, any>(
          `/company-users/${id}`,
          {},
          profile,
          false
        );
        return data;
      }
    } catch (error) {
      return (error as AxiosError).response?.data as ErrorResponse;
    }
  };

  return {
    updateCompanyUser,
  };
};

export const updateUserService = createUpdateUserService(api);
